module.exports = __webpack_public_path__ + "img/gh (4).716db090.png";